import React from "react";
import Skeleton from "../../Common/Skeleton";

const HeaderTabsSkeletons = () => {
  return (
    <div className="flex space-x-3">
      <Skeleton className="rounded-full h-9 w-[95px]" />
      <Skeleton className="rounded-full h-9 w-[95px]" />
      <Skeleton className="rounded-full h-9 w-[95px]" />
    </div>
  );
};

export default HeaderTabsSkeletons;
